// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_3w-0";
export var eligibilityCardNotEligible = "_3w-1";